import Qconsole from './qconsole';

// eslint-disable-next-line no-console
export default new Qconsole(window.console);
